export default "__VITE_ASSET__DJ$vvlHI__"